import React from 'react';
import { Enable_customers_to_select } from '../utils/DictionaryManagementUtils';
import DefaultRecipientList from '../components/PanelsComponents/DefaultPanels/DefaultRecipientList';

//= ========================================================================

const Panel_B02_SendMoneyRecipientList = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultRecipientList
    globJSON={globJSON}
    onConfigChanged={onConfigChanged}
    onStepPressed={onStepPressed}
    onGotoEdit={onGotoEdit}
    selectedScreen={selectedScreen}
    paragraph={Enable_customers_to_select}
    language={language}
  />
);

export default Panel_B02_SendMoneyRecipientList;
